"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 * Get target size of an image with a percentage
 * @param editInfo
 * @param percentage
 * @returns [width, height] array
 */
function getTargetSizeByPercentage(editInfo, percentage) {
    var naturalWidth = editInfo.naturalWidth, naturalHeight = editInfo.naturalHeight, left = editInfo.leftPercent, top = editInfo.topPercent, right = editInfo.rightPercent, bottom = editInfo.bottomPercent;
    var width = naturalWidth * (1 - left - right) * percentage;
    var height = naturalHeight * (1 - top - bottom) * percentage;
    return { width: width, height: height };
}
exports.default = getTargetSizeByPercentage;
//# sourceMappingURL=getTargetSizeByPercentage.js.map